// pt-BR for the wave-3 strings (complete for every key of en-wave3.ts, checked by the type).
import type { enWave3 } from "./en-wave3.ts";

export const ptBRWave3: Record<keyof typeof enWave3, string> = {
  "common.opensNewTab": "(abre em nova aba)",
  "w3.endOfList": "{n} itens — fim da lista.",
  "w3.reason": "Motivo",
  "w3.reasonRequired": "Informe um motivo; ele é registrado na auditoria.",

  "err.blocked": "Bloqueado — não executado",
  "err.blockedBody": "A solicitação foi recusada antes de qualquer execução. Nenhum navegador foi iniciado e nenhum alvo foi contatado.",
  "err.decision": "Decisão: {decision}",

  "project.tab.preview": "Prévia e testes",
  "project.tab.signals": "Incidentes e PRs",
  "overview.previewManage": "Gerenciar prévia",

  "inbox.roleTitle": "A Caixa de entrada é restrita a mantenedores e administradores",
  "inbox.roleBody": "Entregas externas brutas (GitHub, Sentry) podem conter dados sensíveis; por isso só mantenedores e administradores da organização as leem. Seu papel: {role}.",
  "inbox.roleHint": "Incidentes e pull requests dos seus projetos ficam visíveis para todos os papéis.",
  "inbox.seeIncidents": "Ver incidentes",
  "inbox.deliveries": "Entregas",
  "inbox.filters": "Filtros da Caixa de entrada",
  "inbox.filter.state": "Estado",
  "inbox.filter.integration": "Integração",
  "inbox.filter.project": "Projeto",
  "inbox.filter.anyProject": "Qualquer projeto",
  "inbox.filter.unassigned": "Sem projeto (Caixa da organização)",
  "inbox.untrustedNote": "Payloads são dados externos não confiáveis: exibidos como texto, nunca executados nem tratados como instruções.",
  "inbox.loadFailed": "Não foi possível carregar a Caixa de entrada",
  "inbox.emptyTitle": "Nenhuma entrega ainda",
  "inbox.emptyBody": "As entregas aparecem aqui quando uma integração GitHub ou Sentry ativa recebe um webhook.",
  "inbox.emptyFilteredTitle": "Nenhuma entrega corresponde aos filtros",
  "inbox.emptyFilteredBody": "Altere ou limpe os filtros para ver outras entregas.",
  "inbox.col.received": "Recebida",
  "inbox.col.event": "Evento",
  "inbox.col.state": "Estado",
  "inbox.col.project": "Projeto",
  "inbox.col.attempts": "Tentativas",
  "inbox.unassigned": "Sem projeto",
  "inbox.reprocessed": "reprocessada {n}×",
  "inbox.details": "Detalhes",
  "inbox.openDetailFor": "Detalhes da entrega {event} {id}",
  "inbox.detailTitle": "Entrega",
  "inbox.deliveryId": "Id da entrega {id}",
  "inbox.detailFailed": "Não foi possível carregar a entrega",
  "inbox.source": "Origem",
  "inbox.occurred": "Ocorrida",
  "inbox.processed": "Processada",
  "inbox.nextAttempt": "Próxima tentativa",
  "inbox.noNextAttempt": "Nenhuma agendada",
  "inbox.orderingKey": "Chave de ordenação",
  "inbox.correlation": "Id de correlação",
  "inbox.payloadHash": "SHA-256 do payload",
  "inbox.deadLetter": "Dead letter",
  "inbox.lastError": "Último erro",
  "inbox.reprocess": "Reprocessar",
  "inbox.reprocessHint": "Coloca a entrega na fila de novo; o worker a processa com os mapeamentos atuais.",
  "inbox.reprocessUnavailable": "Indisponível enquanto a entrega está {state}: ela já está na fila ou em processamento.",
  "inbox.reprocessQueued": "Reprocessamento solicitado.",
  "inbox.assign": "Atribuir a projeto",
  "inbox.assignTo": "Projeto",
  "inbox.assignHint": "A entrega volta para a fila daquele projeto. É preciso o papel de mantenedor nele.",
  "inbox.assignRole": "É preciso o papel de mantenedor neste projeto para atribuir entregas a ele.",
  "inbox.assignQueued": "Entrega atribuída e recolocada na fila.",
  "inbox.chooseProject": "Escolha um projeto",
  "inbox.headers": "Cabeçalhos armazenados (lista permitida)",
  "inbox.payload": "Payload",
  "inboxState.received": "Recebida",
  "inboxState.processing": "Processando",
  "inboxState.processed": "Processada",
  "inboxState.failed": "Falhou",
  "inboxState.dead_letter": "Dead letter",
  "inboxState.ignored": "Ignorada",
  "inboxSource.github": "GitHub",
  "inboxSource.sentry": "Sentry",

  "integrations.sections": "Seções de integrações",
  "integrations.tab.connections": "Conexões",
  "integrations.tab.incidents": "Incidentes",
  "integrations.tab.prs": "Pull requests",
  "integrations.roleTitle": "Conexões são restritas a mantenedores e administradores",
  "integrations.roleBody": "Mantenedores da organização leem as integrações; administradores as alteram. Seu papel: {role}. Incidentes e pull requests continuam visíveis nas outras abas.",
  "integrations.blockedTitle": "Chamadas reais exigem aprovação explícita",
  "integrations.blockedBody": "Webhooks são recebidos e verificados. O Sentry não faz chamada real. Conexões criadas em \"Conectar GitHub\" só alcançam o GitHub quando o operador libera; trabalho real (pull requests, pushes) exige ainda o id da conexão liberado e a conexão ativa.",
  "integrations.readOnly": "Somente leitura: apenas administradores alteram integrações.",
  "integrations.connections": "Conexões",
  "integrations.loadFailed": "Não foi possível carregar as integrações",
  "integrations.emptyTitle": "Nenhuma integração registrada",
  "integrations.emptyBody": "Um administrador registra a integração GitHub App ou Sentry.",
  "integrations.emptyBodyAdmin": "Registre abaixo uma integração GitHub App ou Sentry. Ela começa como rascunho e não recebe nada até ser ativada.",
  "integrationKind.github_app": "GitHub App",
  "integrationKind.sentry": "Sentry",
  "integrationKind.github_token": "Token do GitHub",
  "integrations.installation": "Instalação",
  "integrations.notInstalled": "Ainda não instalado",
  "integrations.ownershipVerified": "Verificada (token de instalação trocado)",
  "integrations.tokenKind": "Tipo de token",
  "integrations.tokenClassic": "Clássico (acesso amplo)",
  "integrations.tokenFineGrained": "Granular",
  "integrations.tokenExpires": "Expira em",
  "integrations.lastTest": "Último teste",
  "github.connectTitle": "Conectar GitHub",
  "github.appTitle": "GitHub App (recomendado)",
  "github.connectBody": "O MaestrOS cria um GitHub App privado na sua conta ou organização. Você aprova no GitHub e depois instala nos repositórios que o MaestrOS pode usar. As chaves vão direto para o cofre e nunca mais são exibidas.",
  "github.permissions": "Permissões pedidas: ler metadados; escrever código, pull requests e issues; ler Actions. Alterar workflows e checks e criar repositórios ficam desligados até uma decisão futura (D21).",
  "github.ownerType": "Dono",
  "github.ownerUser": "Minha conta pessoal",
  "github.ownerOrg": "Uma organização",
  "github.orgLogin": "Login da organização",
  "github.orgLoginRequired": "Informe o login da organização (letras, números e hífens).",
  "github.connectSubmit": "Continuar no GitHub",
  "github.egressOffTitle": "O GitHub ainda não está acessível nesta instalação",
  "github.egressOff": "As etapas de conexão só chamam o GitHub depois que o operador liberar (github_setup em MAESTROS_ALLOW_REAL_INTEGRATIONS, decisão humana). Até lá elas respondem BLOCKED-external.",
  "github.tokenTitle": "Usar um token",
  "github.tokenBody": "Para contas em que não dá para criar um App: cole um token de acesso pessoal granular de um único dono. Ele vai para o cofre e nunca mais é exibido.",
  "github.tokenOwner": "Login do dono",
  "github.ownerLoginRequired": "Informe o login do GitHub do dono do token.",
  "github.token": "Token de acesso pessoal",
  "github.tokenHint": "Token granular (github_pat_…) limitado aos repositórios que o MaestrOS pode usar.",
  "github.tokenRequired": "Cole o token.",
  "github.acceptClassic": "Aceitar um token clássico (ghp_…)",
  "github.acceptClassicHint": "Um token clássico abre todos os repositórios que a conta alcança. Prefira um token granular.",
  "github.tokenSubmit": "Salvar token",
  "github.tokenCreated": "Token salvo. Rode o teste e depois ative a conexão.",
  "github.install": "Instalar no GitHub",
  "github.reinstall": "Gerenciar instalação",
  "github.result.ok": "Teste aprovado",
  "github.result.failed": "Teste reprovado",
  "github.repositoriesReachable": "{n} repositórios alcançáveis",
  "github.testSteps": "Etapas do teste",
  "github.stepState.passed": "Aprovado",
  "github.stepState.failed": "Reprovado",
  "github.stepState.not_run": "Não executado",
  "github.step.app_jwt": "Chave do App assina um token",
  "github.step.installation": "Instalação pertence a este App",
  "github.step.installation_token": "Token de instalação trocado",
  "github.step.repository_access": "Repositórios alcançáveis",
  "github.step.token": "Token válido e não expirado",
  "github.step.owner": "Token pertence ao dono",
  "github.callbackTitle": "Concluindo o GitHub App",
  "github.callbackWorking": "Registrando o App…",
  "github.callbackDone": "App {name} registrado. Agora instale nos repositórios que o MaestrOS pode usar.",
  "github.missingParams": "Esta página é aberta pelo redirecionamento do GitHub. Comece de novo em Integrações → Conexões.",
  "github.backToIntegrations": "Voltar às integrações",
  "github.installedTitle": "Verificando a instalação",
  "github.installedWorking": "Pedindo ao GitHub para confirmar a instalação…",
  "github.installRequested": "A instalação foi solicitada e aguarda a aprovação de um dono da organização no GitHub. Depois de aprovada, instale de novo pela tela de Integrações.",
  "github.installedDone": "Instalação verificada: {n} repositórios alcançáveis. Mapeie-os para projetos e depois ative a conexão.",
  "integrationState.draft": "Rascunho",
  "integrationState.active": "Ativa",
  "integrationState.suspended": "Suspensa",
  "integrationState.disabled": "Desativada",
  "integrations.githubTarget": "Id do alvo da instalação",
  "integrations.githubTargetHint": "Id numérico enviado em X-GitHub-Hook-Installation-Target-ID.",
  "integrations.githubTargetFormat": "Informe o id numérico do alvo da instalação.",
  "integrations.sentryOrg": "Slug da organização no Sentry",
  "integrations.sentryOrgHint": "Letras minúsculas, dígitos, '-' ou '_'.",
  "integrations.sentryOrgFormat": "Informe o slug da organização (letras minúsculas, dígitos, '-' ou '_').",
  "integrations.appId": "Id do App",
  "integrations.botLogin": "Login do bot",
  "integrations.botLoginHint": "A conta bot do App (ex.: maestros[bot]); eventos dela são ignorados como loops.",
  "integrations.allowedLogins": "Logins autorizados a enviar comandos por comentário",
  "integrations.allowedLoginsHint": "Separados por vírgula. Vazio significa ninguém (negação por padrão).",
  "integrations.ownership": "Prova de propriedade",
  "integrations.ownershipAttested": "Declaração manual registrada (não verificada)",
  "integrations.ownershipMissing": "Ausente",
  "integrations.ownershipStatement": "Declaração de propriedade",
  "integrations.ownershipHint": "Explique por que esta organização é dona do alvo da instalação (mínimo de 10 caracteres).",
  "integrations.ownershipUnverified": "Uma prova real exige chamada ao GitHub e está BLOCKED-external: a declaração é registrada como não verificada.",
  "integrations.realNetwork": "Rede real",
  "integrations.allowlisted": "na lista permitida para um teste aprovado futuro",
  "integrations.notAllowlisted": "fora da lista permitida",
  "integrations.updated": "Atualizada",
  "integrations.webhookUrl": "URL do webhook para o operador",
  "integrations.webhookGithubHint": "Configure esta URL no GitHub App. As entregas são roteadas pelo cabeçalho do alvo da instalação ({target}); use o segredo de webhook armazenado abaixo.",
  "integrations.webhookSentryHint": "Configure esta URL na integração do Sentry. A rota carrega o id desta integração ({id}); use o client secret armazenado abaixo.",
  "integrations.copy": "Copiar",
  "integrations.webhookCopied": "URL do webhook copiada.",
  "integrations.copyFailed": "Não foi possível copiar; selecione a URL e copie manualmente.",
  "integrations.secrets": "Segredos",
  "integrations.secretsWriteOnly": "Somente escrita: guardados no cofre; só o estado e uma dica mascarada voltam.",
  "integrations.webhookSecret": "Segredo do webhook",
  "integrations.sentryClientSecret": "Client secret",
  "integrations.appPrivateKey": "Chave privada do App",
  "integrations.keyHint": "Escolha o arquivo .pem; a chave nunca é exibida.",
  "integrations.keyLoaded": "Chave carregada ({n} caracteres). Enviada uma vez e nunca exibida.",
  "integrations.setSecret": "Definir",
  "integrations.replaceSecret": "Substituir",
  "integrations.revokeSecret": "Revogar",
  "integrations.replaceTitle": "Armazenar {label}",
  "integrations.revokeTitle": "Revogar {label}",
  "integrations.revokeBody": "O segredo é revogado no cofre. Armazene um novo para usá-lo de novo.",
  "integrations.revokeWebhookBody": "Sem o segredo do webhook a integração não recebe entregas: uma integração ativa ou suspensa volta para rascunho.",
  "integrations.secretRequired": "Informe o valor do segredo.",
  "integrations.secretMin": "Segredos de webhook precisam de pelo menos 16 caracteres.",
  "integrations.secretActivationHint": "Obrigatório antes da ativação. Pelo menos 16 caracteres.",
  "integrations.secretStored": "Segredo armazenado.",
  "integrations.secretRevoked": "Segredo revogado.",
  "integrations.activate": "Ativar",
  "integrations.reactivate": "Reativar",
  "integrations.suspend": "Suspender",
  "integrations.disable": "Desativar",
  "integrations.enable": "Ativar",
  "integrations.test": "Testar conexão",
  "integrations.testResult": "Resultado do teste",
  "integrations.activateTitle": "Ativar {name}",
  "integrations.suspendTitle": "Suspender {name}",
  "integrations.disableTitle": "Desativar {name}",
  "integrations.activateBody": "A integração passa a aceitar entregas; as retidas são liberadas. É necessário um segredo de webhook armazenado.",
  "integrations.suspendBody": "As entregas continuam sendo registradas, mas ficam retidas (sem processamento) até a integração ser ativada de novo.",
  "integrations.disableBody": "As entregas são rejeitadas. A configuração e o histórico são mantidos.",
  "integrations.statementMin": "A declaração precisa de pelo menos 10 caracteres.",
  "integrations.activationRefused": "Ativação recusada",
  "integrations.activationRefusedBody": "O servidor recusou a ativação. Por segurança, ele não informa o motivo (por exemplo, o alvo pode já estar em uso ou o estado mudou). Recarregue e confira a integração; procure um administrador se persistir.",
  "integrations.done.activate": "Integração ativada.",
  "integrations.done.suspend": "Integração suspensa.",
  "integrations.done.disable": "Integração desativada.",
  "integrations.editTitle": "Editar {name}",
  "integrations.refChangeHint": "Trocar o alvo devolve uma integração ativa para rascunho: ela precisa de nova declaração de propriedade e nova ativação.",
  "integrations.saved": "Integração salva.",
  "integrations.register": "Registrar uma integração",
  "integrations.registerSubmit": "Registrar como rascunho",
  "integrations.identity": "Identificação",
  "integrations.kind": "Tipo",
  "integrations.name": "Nome",
  "integrations.nameRequired": "Informe um nome.",
  "integrations.created": "Integração registrada como rascunho.",
  "integrations.mappings": "Mapeamentos de projeto",
  "integrations.mappingGithubHint": "Mapeia um repositório (owner/repo) para um projeto. Entregas sem mapeamento ficam na Caixa de entrada da organização.",
  "integrations.mappingSentryHint": "Mapeia um projeto do Sentry (slug ou id) para um projeto, opcionalmente limitado a ambientes.",
  "integrations.noMappings": "Nenhum mapeamento ainda.",
  "integrations.repository": "Repositório",
  "integrations.sentryProject": "Projeto no Sentry",
  "integrations.environments": "Ambientes",
  "integrations.allEnvironments": "Todos",
  "integrations.addMapping": "Adicionar mapeamento",
  "integrations.mappingRequired": "Escolha um projeto e informe a referência externa.",
  "integrations.mappingCreated": "Mapeamento adicionado.",
  "integrations.removeMapping": "Remover",
  "integrations.removeMappingTitle": "Remover mapeamento",
  "integrations.removeMappingBody": "Entregas de {ref} deixarão de ser roteadas para este projeto.",
  "integrations.prDelivery": "Pull requests",
  "integrations.prDeliveryOffLabel": "Desligados",
  "integrations.prDeliveryRate": "Ligados (até {n}/h)",
  "integrations.prDeliveryEnable": "Ligar PRs",
  "integrations.prDeliveryDisable": "Desligar PRs",
  "integrations.prDeliveryTitle": "Ligar a entrega de pull requests",
  "integrations.prDeliveryBody": "As tarefas aprovadas deste projeto passam a ser enviadas como branches e pull requests reais em {ref} (até {n} por hora), inclusive as que já aguardam liberação. O merge continua sendo de vocês.",
  "integrations.prDeliveryOn": "Entrega de pull requests ligada.",
  "integrations.prDeliveryOff": "Entrega de pull requests desligada.",

  "incidents.title": "Incidentes",
  "incidents.filter.state": "Estado",
  "incidents.filter.project": "Projeto",
  "incidents.unassigned": "Sem projeto",
  "incidents.loadFailed": "Não foi possível carregar os incidentes",
  "incidents.emptyTitle": "Nenhum incidente",
  "incidents.emptyBody": "Issues do Sentry roteadas para seus projetos aparecem aqui quando uma integração Sentry estiver ativa.",
  "incidents.col.title": "Incidente",
  "incidents.col.state": "Estado",
  "incidents.col.environment": "Ambiente",
  "incidents.col.events": "Eventos",
  "incidents.col.lastSeen": "Visto por último",
  "incidents.col.task": "Tarefa",
  "incidents.firstSeen": "primeiro {when}",
  "incidents.openTask": "Abrir tarefa",
  "incidents.noTask": "Sem tarefa",
  "incidentState.open": "Aberto",
  "incidentState.linked": "Vinculado",
  "incidentState.resolved": "Resolvido",
  "incidentState.ignored": "Ignorado",
  "incidentState.regressed": "Regrediu",
  "prs.title": "Pull requests",
  "prs.loadFailed": "Não foi possível carregar os pull requests",
  "prs.emptyTitle": "Nenhum pull request vinculado",
  "prs.emptyBody": "Pull requests abertos para tarefas são vinculados aqui a partir das entregas do GitHub.",
  "prs.col.pr": "Pull request",
  "prs.col.state": "Estado",
  "prs.col.branch": "Branch base",
  "prs.col.head": "Head",
  "prs.col.task": "Tarefa",
  "prs.col.updated": "Atualizado",
  "prs.headSeq": "head nº {n}",
  "prState.open": "Aberto",
  "prState.merged": "Mesclado",
  "prState.closed": "Fechado",

  "browser.intro": "Alvos de prévia, contas de teste, cenários e execuções de navegador deste projeto. O executor de navegador ainda não está instalado (D11.1); execuções e capturas são recusadas e exibidas como tal.",
  "preview.title": "Prévia",
  "preview.loadFailed": "Não foi possível carregar a prévia",
  "preview.emptyTitle": "Nenhum alvo de prévia",
  "preview.emptyBody": "Registre a URL de um ambiente deste projeto. Uma prévia não é uma publicação em produção.",
  "preview.state.preparing": "Preparando",
  "preview.state.available": "Disponível",
  "preview.state.stale": "Desatualizado",
  "preview.state.unavailable": "Indisponível",
  "preview.staleLabel": "Desatualizado",
  "preview.stale.not_checked": "ainda não verificado",
  "preview.stale.candidate_differs": "a tarefa tem um candidato mais novo",
  "preview.stale.capture_without_candidate": "captura sem candidato",
  "preview.candidate": "Candidato",
  "preview.currentCandidate": "Atual",
  "preview.candidateMatches": "corresponde ao candidato atual da tarefa",
  "preview.candidateUnknown": "sem candidato da tarefa para comparar",
  "preview.checkedAt": "verificado {when}",
  "preview.neverChecked": "nunca verificado",
  "preview.frameTitle": "Prévia ao vivo de {url}",
  "preview.noEmbedTitle": "Não incorporado no painel",
  "preview.policy.new_tab_only": "O alvo não permite ser exibido dentro deste painel; abra em uma nova aba.",
  "preview.policy.capture_only": "O alvo só permite ver uma captura.",
  "preview.policy.embeddable_blocked": "O alvo poderia ser incorporado, mas a prévia não está atualizada; abra em nova aba ou veja a captura.",
  "preview.embedReason": "Motivo",
  "preview.embedSource": "Fonte",
  "preview.openNewTab": "Abrir em nova aba",
  "preview.downloadCapture": "Baixar captura",
  "preview.captureFacts": "Captura de {when}",
  "preview.noCapture": "Nenhuma captura ainda.",
  "preview.noAlternatives": "Nenhuma alternativa disponível para este alvo.",
  "preview.capture": "Capturar",
  "preview.environment": "Ambiente",
  "preview.noEnvironment": "Sem ambiente",
  "preview.task": "Tarefa",
  "preview.register": "Registrar um alvo de prévia",
  "preview.registerHint": "A URL precisa ser permitida pelo ambiente. A decisão de incorporação é recalculada pelo servidor a cada leitura.",
  "preview.url": "URL",
  "preview.urlFormat": "Informe uma URL http(s).",
  "preview.registerSubmit": "Registrar",
  "preview.registered": "Alvo de prévia registrado.",
  "testAccounts.title": "Contas de teste",
  "testAccounts.intro": "Credenciais são somente escrita: guardadas no cofre, nunca exibidas nem devolvidas — só o estado.",
  "testAccounts.empty": "Nenhuma conta de teste.",
  "testAccounts.label": "Rótulo",
  "testAccounts.username": "Usuário",
  "testAccounts.hosts": "Hosts permitidos",
  "testAccounts.hostsHint": "host, host:porta ou *.domínio — separados por vírgula.",
  "testAccounts.hostsRequired": "Informe pelo menos um host permitido.",
  "testAccounts.credentials": "Credenciais",
  "testAccounts.password": "Senha",
  "testAccounts.totp": "Semente TOTP",
  "testAccounts.totpHint": "Semente base32; somente escrita.",
  "testAccounts.writeOnly": "Somente escrita: enviadas uma vez, nunca exibidas de novo.",
  "testAccounts.rotatePassword": "Trocar senha",
  "testAccounts.rotateTotp": "Trocar TOTP",
  "testAccounts.setTotp": "Definir TOTP",
  "testAccounts.revokeTotp": "Revogar TOTP",
  "testAccounts.revokeTotpBody": "A semente TOTP é revogada e toda sessão armazenada desta conta é invalidada.",
  "testAccounts.disable": "Desativar",
  "testAccounts.disableTitle": "Desativar {label}",
  "testAccounts.disableBody": "A conta é desativada, suas credenciais são revogadas no cofre e toda sessão é invalidada. O registro permanece para auditoria.",
  "testAccounts.disableHint": "Desativar invalida toda sessão armazenada.",
  "testAccounts.add": "Adicionar conta de teste",
  "testAccounts.identity": "Conta",
  "testAccounts.chooseEnv": "Escolha um ambiente",
  "testAccounts.noEnvironments": "Este projeto ainda não tem ambiente; adicione um nas configurações do projeto.",
  "testAccounts.envRequired": "Escolha um ambiente.",
  "testAccounts.required": "Obrigatório.",
  "testAccounts.create": "Adicionar conta de teste",
  "testAccounts.created": "Conta de teste adicionada.",
  "testAccounts.editTitle": "Editar {label}",
  "testAccounts.usernameChangeHint": "Trocar o usuário invalida toda sessão armazenada.",
  "testAccounts.secretTitle": "Armazenar {label}",
  "testAccounts.secretStored": "Credencial armazenada.",
  "testAccounts.sessionsRevokedHint": "Armazenar uma nova credencial invalida toda sessão armazenada desta conta.",
  "sessions.title": "Sessões de navegador",
  "sessions.empty": "Nenhuma sessão armazenada.",
  "sessions.storedIn": "estado de armazenamento: {state} (cofre)",
  "sessions.obtained": "obtida {when}",
  "sessions.revoke": "Revogar",
  "sessionState.valid": "Válida",
  "sessionState.expired": "Expirada",
  "sessionState.revoked": "Revogada",
  "sessionState.invalid": "Inválida",
  "scenarios.title": "Cenários",
  "scenarios.empty": "Nenhum cenário.",
  "scenarios.key": "Cenário",
  "scenarios.account": "Conta de teste",
  "scenarios.noAccount": "Sem conta",
  "scenarios.hash": "Hash do corpo",
  "scenarios.run": "Executar",
  "scenarios.activate": "Ativar",
  "scenarios.retire": "Aposentar",
  "scenarios.runResult": "Execução de {key}",
  "scenarios.runAccepted": "Execução aceita; ela aparece na lista abaixo.",
  "scenarios.add": "Adicionar cenário",
  "scenarios.body": "Cenário (maestros.browser.scenario.v1)",
  "scenarios.bodyHint": "JSON declarativo: passos fixos, sem scripts, sem segredos literais (use fill_secret). A versão é atribuída pelo servidor.",
  "scenarios.bodyJson": "O cenário não é um JSON válido.",
  "scenarios.bodyObject": "O cenário precisa ser um objeto JSON.",
  "scenarios.create": "Salvar como rascunho",
  "scenarios.created": "Cenário salvo como rascunho.",
  "scenarioState.draft": "Rascunho",
  "scenarioState.active": "Ativo",
  "scenarioState.retired": "Aposentado",
  "browserRuns.title": "Execuções de navegador",
  "browserRuns.blockedNote": "O executor de navegador não está instalado (D11.1) e execuções em staging exigem autorização humana (D11.2): novas execuções são recusadas com resultado BLOCKED.",
  "browserRuns.emptyTitle": "Nenhuma execução de navegador",
  "browserRuns.emptyBody": "As execuções aparecem aqui quando o executor for autorizado e um cenário rodar.",
  "browserRuns.scenario": "Cenário",
  "browserRuns.status": "Status",
  "browserRuns.mode": "Modo",
  "browserRuns.blocked": "Requisições bloqueadas",
  "browserRuns.blockedCount": "{n} bloqueadas",
  "browserRuns.created": "Criada",
  "browserRuns.trace": "Trace",
  "browserRuns.downloadTrace": "Baixar trace",
  "runStatus.queued": "Na fila",
  "runStatus.running": "Executando",
  "runStatus.passed": "Passou",
  "runStatus.failed": "Falhou",
  "runStatus.aborted": "Abortada",
  "runStatus.paused": "Pausada",
  "runStatus.rejected": "Rejeitada",
  "runMode.local_fixture": "Fixture local",
  "runMode.mock": "Serviços simulados",
  "runMode.staging": "Staging",

  "memory.projectOnly": "A memória pertence só a este projeto; nada é compartilhado com outros projetos nem recuperado deles.",
  "memory.project": "Projeto",
  "memory.projectHint": "A memória é por projeto.",
  "memory.openInProject": "Abrir no projeto",
  "memory.noProjectsTitle": "Nenhum projeto ainda",
  "memory.noProjectsBody": "A memória é mantida por projeto. Crie um projeto para iniciar a memória dele.",
  "memory.sections": "Seções da memória",
  "memory.tab.search": "Busca",
  "memory.tab.sources": "Fontes",
  "memory.tab.index": "Índice e avaliações",
  "memory.tab.stats": "Estatísticas",
  "memory.searchTitle": "Buscar na memória",
  "memory.query": "Pergunta ou palavras-chave",
  "memory.queryRequired": "Informe o que buscar.",
  "memory.k": "Resultados (k)",
  "memory.strategy": "Estratégia",
  "memory.strategyHint": "Estratégias vetoriais e com rerank dependem de provedores BLOCKED-external.",
  "memory.strategyDefault": "Padrão do índice",
  "memory.includeHistorical": "Incluir versões históricas",
  "memory.search": "Buscar",
  "memory.resultMeta": "{n} resultados · {strategy} · {latency}",
  "memory.degradedNotice": "Busca semântica indisponível — exibindo resultados por texto (falha no embedding ou na reordenação).",
  "memory.indexVersion": "índice",
  "memory.eligibleChunks": "{n} trechos elegíveis",
  "memory.noHits": "Nada relevante encontrado",
  "memory.noHitsBody": "Nenhuma fonte atual corresponde. Tente outras palavras ou inclua versões históricas.",
  "memory.score": "pontuação {score}",
  "memory.provenance": "Proveniência",
  "memory.sourceRef": "Fonte",
  "memory.commit": "Commit",
  "memory.author": "Autor",
  "memory.classification": "Classificação",
  "memory.lines": "Linhas",
  "memory.scores": "Pontuações",
  "memory.symbols": "Símbolos",
  "memory.supersededBy": "Substituída por",
  "memory.current": "Atual",
  "memory.historical": "Histórica",
  "memory.sourcesTitle": "Fontes",
  "memory.filter.state": "Estado",
  "memory.filter.kind": "Tipo",
  "memory.filter.versions": "Versões",
  "memory.filter.currentOnly": "Somente atuais",
  "memory.filter.historicalOnly": "Somente históricas",
  "memory.filter.allVersions": "Todas as versões",
  "memory.sourcesFailed": "Não foi possível carregar as fontes da memória",
  "memory.noSourcesTitle": "Nenhuma fonte",
  "memory.noSourcesBody": "Um mantenedor adiciona decisões, versões de PRD ou arquivos do repositório à memória deste projeto.",
  "memory.noSourcesBodyMaintainer": "Adicione abaixo uma decisão, uma versão de PRD ou arquivos do repositório.",
  "memory.col.source": "Fonte",
  "memory.col.state": "Estado",
  "memory.col.origin": "Autor / commit",
  "memory.col.created": "Criada",
  "memory.versions": "Versões",
  "memory.versionHistory": "Histórico de versões",
  "memory.contentHash": "Hash do conteúdo",
  "memory.reject": "Rejeitar",
  "memory.rejectTitle": "Rejeitar {key}",
  "memory.rejectBody": "A versão permanece no histórico, mas deixa de ser recuperada como conhecimento.",
  "memory.tombstone": "Esquecer (tombstone)",
  "memory.tombstoneTitle": "Esquecer {key}",
  "memory.tombstoneBody": "Remove toda versão, trecho e embedding desta fonte e registra um tombstone para que ela não seja ingerida de novo. Não pode ser desfeito.",
  "memory.tombstoned": "{key} esquecida",
  "memory.tombstoneCounts": "{versions} versões, {chunks} trechos, {embeddings} embeddings e {retrievals} registros de recuperação removidos.",
  "memory.ingestTitle": "Adicionar à memória",
  "memory.ingestHint": "Conhecimento não validado entra como candidato, nunca automaticamente como fato.",
  "memory.origin": "Origem",
  "memory.origin.decision": "Decisão",
  "memory.origin.prd_version": "Versão de PRD",
  "memory.origin.repository": "Arquivos do repositório",
  "memory.decisionKey": "Chave",
  "memory.decisionKeyHint": "Id estável (minúsculas, dígitos, '.', '_' ou '-'); novo texto para a mesma chave cria uma nova versão.",
  "memory.decisionTitle": "Título",
  "memory.decisionBody": "Decisão",
  "memory.evidence": "Referências de evidência",
  "memory.evidenceHint": "Uma por linha (ADR, PR, registro de decisão). Obrigatória para uma decisão validada.",
  "memory.requestValidated": "Solicitar estado validado",
  "memory.validatedHint": "Respeitado só para um mantenedor autenticado com pelo menos uma referência de evidência.",
  "memory.prdVersion": "Versão de PRD",
  "memory.choosePrdVersion": "Escolha uma versão de PRD",
  "memory.noPrdVersions": "Este projeto ainda não tem versão de PRD.",
  "memory.workspace": "Workspace",
  "memory.chooseWorkspace": "Escolha um workspace",
  "memory.noWorkspaces": "Este projeto não tem workspace.",
  "memory.paths": "Caminhos",
  "memory.pathsHint": "Um por linha, relativos ao workspace. Acesso git somente leitura no commit informado.",
  "memory.ingest": "Adicionar",
  "memory.ingested": "Memória atualizada.",
  "memory.ingestResult": "Resultado por fonte",
  "memory.outcome": "Resultado",
  "memory.detail": "Detalhe",
  "memory.chunks": "{n} trechos",
  "memOutcome.created": "Criada",
  "memOutcome.unchanged": "Sem mudança",
  "memOutcome.refused": "Recusada",
  "memKind.markdown": "Markdown",
  "memKind.prd": "PRD",
  "memKind.code": "Código",
  "memKind.text": "Texto",
  "memState.candidate": "Candidata",
  "memState.validated": "Validada",
  "memState.obsolete": "Obsoleta",
  "memState.rejected": "Rejeitada",
  "memory.statsTitle": "Estatísticas",
  "memory.statsSources": "Fontes",
  "memory.statsIndex": "Índice ativo",
  "memory.statsRetrievals": "Recuperações",
  "memory.stat.current": "Fontes atuais",
  "memory.stat.historical": "Versões históricas",
  "memory.stat.withoutEvidence": "Sem evidência",
  "memory.stat.obsolete": "Obsoletas",
  "memory.stat.rejected": "Rejeitadas",
  "memory.stat.tombstoned": "Chaves esquecidas",
  "memory.stat.oldest": "atual mais antiga: {when}",
  "memory.stat.newest": "mais recente: {when}",
  "memory.stat.chunks": "Trechos",
  "memory.stat.bytes": "Bytes de conteúdo",
  "memory.stat.duplicates": "Grupos duplicados",
  "memory.stat.conflicts": "Símbolos em conflito",
  "memory.stat.retrievals": "Recuperações",
  "memory.stat.empty": "Sem resultados",
  "memory.stat.latencyMean": "Latência média",
  "memory.stat.latencyP95": "Latência p95",
  "memory.stat.tokens": "Tokens inseridos (estimativa)",
  "memory.stat.cost": "Custo de recuperação",
  "memory.noActiveIndex": "Nenhuma versão de índice ativa: a busca fica indisponível até uma ser construída, avaliada e ativada.",
  "memory.unknown": "desconhecido",
  "memIndex.title": "Versões do índice",
  "memIndex.intro": "Construa uma versão, avalie-a em um dataset, compare com a ativa e então ative-a. A ativação confere qual versão está ativa agora; se mudou, recarregue.",
  "memIndex.serving": "Em uso",
  "memIndex.noneServing": "Nenhuma versão em uso",
  "memIndex.emptyTitle": "Nenhuma versão de índice",
  "memIndex.emptyBody": "Um mantenedor constrói a primeira versão (a estratégia de texto não tem custo de provedor).",
  "memIndex.version": "Versão",
  "memIndex.status": "Status",
  "memIndex.dates": "Datas",
  "memIndex.chunking": "chunking {v}",
  "memIndex.servingBadge": "em uso",
  "memIndex.noEmbedder": "sem embedder",
  "memIndex.createdAt": "criada {when}",
  "memIndex.activatedAt": "ativada {when}",
  "memIndex.retiredAt": "aposentada {when}",
  "memIndex.building": "Construindo",
  "memIndex.ready": "Pronta",
  "memIndex.active": "Ativa",
  "memIndex.retired": "Aposentada",
  "memIndex.failed": "Falhou",
  "memIndex.evaluate": "Avaliar",
  "memIndex.compare": "Comparar",
  "memIndex.activate": "Ativar",
  "memIndex.retire": "Aposentar",
  "memIndex.needDataset": "Crie um dataset primeiro.",
  "memIndex.buildStrategy": "Estratégia",
  "memIndex.buildHint": "Só texto funciona agora; provedores de embedding e rerank estão BLOCKED-external.",
  "memIndex.build": "Construir versão",
  "memIndex.built": "Versão do índice construída.",
  "memIndex.activated": "Versão do índice ativada.",
  "memIndex.rollback": "Reverter",
  "memIndex.rolledBack": "Revertido para a versão anterior.",
  "memIndex.retireTitle": "Aposentar versão do índice",
  "memIndex.retireBody": "A versão deixa de ser pesquisável e não pode ser ativada de novo.",
  "memIndex.evaluateTitle": "Avaliar versão do índice",
  "memIndex.compareTitle": "Comparar com a referência",
  "memIndex.baseline": "Referência",
  "memIndex.baselineActive": "Versão ativa",
  "memIndex.target": "Esta versão",
  "memIndex.delta": "Variação",
  "memIndex.promotable": "Pode ser promovida",
  "memIndex.promotableBody": "As regras de ciclo de vida permitem ativar esta versão.",
  "memIndex.notPromotable": "Ainda não pode ser promovida",
  "memDataset.title": "Datasets de avaliação",
  "memDataset.empty": "Nenhum dataset.",
  "memDataset.name": "Nome",
  "memDataset.cases": "Casos",
  "memDataset.hash": "Hash do corpo",
  "memDataset.freeze": "Congelar",
  "memDataset.retire": "Aposentar",
  "memDataset.draft": "Rascunho",
  "memDataset.frozen": "Congelado",
  "memDataset.retired": "Aposentado",
  "memDataset.add": "Criar um dataset",
  "memDataset.casesLabel": "Casos (JSON)",
  "memDataset.casesHint": "Array de {case_key, question, expected[{source_key, symbol?}], forbidden_source_keys, stale_source_keys}. expected vazio = pergunta negativa.",
  "memDataset.casesJson": "Os casos não são um JSON válido.",
  "memDataset.casesArray": "Informe um array JSON de casos não vazio.",
  "memDataset.nameRequired": "Informe um nome.",
  "memDataset.create": "Criar dataset",
  "memDataset.created": "Dataset criado.",
  "memEval.title": "Avaliações",
  "memEval.dataset": "Dataset",
  "memEval.runActive": "Avaliar versão ativa",
  "memEval.againstActive": "Roda contra a versão de índice ativa.",
  "memEval.noActive": "Sem versão ativa: avalie uma versão específica na lista acima.",
  "memEval.running": "Avaliando…",
  "memEval.failed": "A avaliação falhou",
  "memEval.empty": "Nenhuma avaliação ainda.",
  "memEval.metric": "Métrica",
  "memEval.recall": "Recall@k",
  "memEval.contamination": "Contaminação",
  "memEval.staleAsCurrent": "Obsoletas como atuais",
  "memEval.reportHash": "Hash do relatório",
  "memEvalState.running": "Executando",
  "memEvalState.completed": "Concluída",
  "memEvalState.failed": "Falhou",

  "infra.coolifyReadOnly": "teste somente leitura",
};
